import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Our components
import TrackingDrawer from '../../../pages/General/TrackingDrawer'
import Carrier from '../../General/Carrier'
import OrderStatus from '../../General/OrderStatus'
import Customer from '../../../pages/General/Customer'
import CarrierTracking from '../../../pages/General/CarrierTracking'
import Filters from './Filters'
import Search from './Search'
import DynamicColumns from '../../../pages/General/DynamicColumns'
import Notification from '../../../pages/General/Notification'
import NorowsData from '../../../pages/General/NorowsData'
import Date from '../../../pages/General/Date'
import OrderDrawer from '../../../pages/General/OrderDrawer'
import ShipmentRate from '../../../pages/General/ShipmentRate'
import Printer from '../../../pages/General/Printer'

// mui components
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Card,
    Button,
    Select,
    MenuItem,
    Stack
} from "@mui/material";
import TextField from "@mui/material/TextField";
import LinearProgress from '@mui/material/LinearProgress';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ViewColumnSharpIcon from '@mui/icons-material/ViewColumnSharp';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Badge from '@mui/material/Badge';
import ClearIcon from "@mui/icons-material/Clear";
import AdfScannerOutlinedIcon from '@mui/icons-material/AdfScannerOutlined';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {
    doGetMysqlDeliveries,
    fetchDeliveriesColumns,
    saveDeliveriesColumns,
    fetchShipmentCategoryCountData,
    resetDeliveriessNotifications
} from './departureSlice';
import { fetchCustomerDetails } from './trackingEventsSlice';
import {
    fetchOrderDetail
} from '../../../pages/OrderDetail/orderdetailsSlice';
import PageSearch from '../../../pages/General/PageSearch'
import { fetchLabelData,departureScan, resetLabelData, resetLabel } from "../../../pages/Dashboard/dashboardSlice";

// Shared dictionary defining standard control focus layout rings
const enterpriseControlInputStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& input': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiSelect-select': {
        padding: '8px 14px !important',
        fontSize: '13px',
        color: '#1E293B',
        fontWeight: 500
    }
};

const departurePageUtilityIconStyles = (isActive) => ({
    color: '#1976d2',
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: isActive ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
    border: isActive ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid #E2E8F0',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: isActive ? 'rgba(25, 118, 210, 0.12)' : 'rgba(241, 245, 249, 0.8)',
        borderColor: isActive ? 'rgba(25, 118, 210, 0.3)' : '#CBD5E1',
        transform: 'translateY(-1px)'
    },
    '&:active': { transform: 'translateY(0)' }
});

const DeparturePage = () => {
    const dispatch = useDispatch();
    const deliveries = useSelector(state => state.departure);
    console.log(deliveries)
    const departureScanUpdate = useSelector((state) => state.dashboard && state.dashboard.departurescan);
    const profile = useSelector(state => state.auth);
    const [meta, setMeta] = useState(deliveries.deliveriesData.meta);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [showScan, setShowScan] = useState(true);
    const [departureScanStatus, setDepartureScanStatus] = useState(true);
    const [showDynamicColumn, setShowDynamicColumn] = useState(false);
    const [columnCheckedObject, setColumnCheckedObject] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isMultiPiece, setIsMultiPiece] = useState(false)
    const [value, setValue] = React.useState(0);
    const [detartureTrackingNumber, setDetartureTrackingNumber] = useState("");
    const [detartureTrackingNumberErrors, setDetartureTrackingNumberErrors] = useState(null);
    const [trackingnumberSubmit, settrackingnumberSubmit] = useState(false);
    const [pageNumber, setPageNumber] = useState("")
    const deperturScanValidate = () => {
        if (detartureTrackingNumber!=="") {
          setDetartureTrackingNumberErrors("");
         }
        }
    
      const departureScanHandleSubmit = () => {
        if (detartureTrackingNumber == "") {
          setDetartureTrackingNumberErrors("Tracking Number is required");
        }  else {
            setDetartureTrackingNumberErrors("");
            let depertureData={
                "tracking_number":detartureTrackingNumber
            }
            settrackingnumberSubmit(true)
            dispatch(departureScan(profile.profile.id,depertureData));    
        }
      };

      const onInputClear = () => {
        setDetartureTrackingNumber("");
        settrackingnumberSubmit(false)
      };

    const orderCallback = (item) => {
        dispatch(fetchOrderDetail(item));
        setOrderDrawerVisible(true)
    }
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };

    let defaultColumns = [{
        field: 'order_id',
        headerName: 'Order',
        headerClassName: 'super-app-theme--header',
        minWidth: 180,
        sortable: true,
        flex: 1,
        renderCell: (params) => {
            return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { orderCallback(params.row.order_id) }}>{params.row.order_id}</span>

        }
    },
    {
        field: 'tracking_number',
        headerName: 'Tracking Number',
        minWidth: 250,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            let tracking_number = (params.row.tracking_number
                && typeof params.row.tracking_number !== "undefined" && params.row.tracking_number !== null)
                ? params.row.tracking_number : "";
            let carrier_name = (params.row.label_carrier_name
                && typeof params.row.label_carrier_name !== "undefined" && params.row.label_carrier_name !== null)
                ? params.row.label_carrier_name : "";
            let message = (params.row && params.row.is_manifest_closed === false)
                ? "This shipment manifest is not yet closed" : null;
            let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
            return (
                <CarrierTracking trackingItems={tracking} dispatchCallback={trackingCallback} carrierImageWidth="60px" message={message} />
            )
        }
    },
    {
        field: 'departure_scan_at',
        headerName: 'Departure Scan Date',
        minWidth: 180,
        flex: 1,
        renderCell: (params) => {
            if (params.row && params.row.departure_scan_at) {
                return <Date date={params.row.departure_scan_at} />
            } else {
                return "-"
            }
        }
    },
    {
        field: 'action',
        headerName: 'Shipment Action',
        minWidth: 200,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            const trackingNumber = params.row.tracking_number ? params.row.tracking_number : "";
            let voided = ((params.row.is_void_in_progress && params.row.is_void_in_progress !== null) || (params.row.is_voided && params.row.is_voided !== null)) ? true : false
            if (trackingNumber != "" && voided != true && ((params.row.detachable_label_url) || (params.row.detachable_direct_label_url) || (params.row.label_url && params.row.label_url != "") || (params.row.direct_label_url && params.row.direct_label_url != ""))) {

                let url = "";
                if (params.row.detachable_label_url && params.row.detachable_label_url != "") {
                    url = params.row.detachable_label_url
                } else if (params.row.detachable_direct_label_url && params.row.detachable_direct_label_url != "") {
                    url = params.row.detachable_direct_label_url
                } else if (params.row.label_url && params.row.label_url != "") {
                    url = params.row.label_url
                } else if (params.row.direct_label_url && params.row.direct_label_url != "") {
                    url = params.row.direct_label_url
                }

                return <div>
                    <span style={{ marginRight: '10px' }}><Tooltip title="View" placement="left-start">
                        <IconButton onClick={() => window.open(url, '_blank')}>
                            <RemoveRedEyeIcon style={{ color: "#1890ff", cursor: 'pointer' }}  />
                        </IconButton>
                    </Tooltip>
                    </span>
                    <span style={{ marginRight: '10px' }}><Tooltip title="Print" placement="left-start">
                        <IconButton  onClick={() => { setPrintUrl(url); setIsPrinted(false) }} >
                            <LocalPrintshopIcon style={{ color: "#1890ff", cursor: 'pointer' }}
                               />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
            } else {
                return <>-</>
            }
        }
    }]
    const [columns, setColumns] = useState(defaultColumns);

    const tabOnClick = (e,value) => {
        setValue(value);
        let shipment_status=""
        if(value==0){
            shipment_status=""
        }else if(value==1){
            shipment_status="Label Generated"
        }else if(value==2){
            shipment_status="In Transit"
        }else if(value==3){
            shipment_status="Issues"
        }else if(value==4){
            shipment_status="Delivered"
        }else if(value==5){
            shipment_status="Untracked"
        }else if(value==6){
            shipment_status="Voided"
        }
        setMeta({
            ...meta,
            ...{
                shipment_status_category: [shipment_status],
            }
        });
      };
   


    useEffect(() => {
        dispatch(fetchDeliveriesColumns());
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                order_status: [],
                receiver_province: "",
                receiver_country_code: "",
                tracking_number: "",
                carrier_name: [],
                platform_tags: [],
                customer_name: "",
                shipment_status_category: [],
                shippingchimp_manifest_number: "",
                unclosed_shipment: 'false',
                sorting: JSON.stringify([{
                    field: 'shipment_date',
                    sort: 'desc',
                }])
            }
        });
    }, [dispatch])

    useEffect(() => {
        dispatch(doGetMysqlDeliveries({ ...meta }));
    }, [meta])

    const trackingCallback = (carriername, trackingNumber, message = null) => {
        setTrackingMessage(message)
        let apikey = (profile && profile.profile && profile.profile.api_token) ? profile.profile.api_token : "";
        const data = { 'tracking_number': trackingNumber }
        dispatch(fetchCustomerDetails(data, apikey))
        setTrackingDrawerVisible(true)
    }
    const onClose = (values) => {
        setTrackingDrawerVisible(false);
    };
    useEffect(() => {
        if (departureScanUpdate && departureScanUpdate.notification && departureScanUpdate.notification.messageContent
            && departureScanUpdate.notification.messageContent[0] === 'Departure Scan updated successfully') {
              setDetartureTrackingNumber("");
              settrackingnumberSubmit(false)
              dispatch(doGetMysqlDeliveries({ ...meta }));
            }
    }, [departureScanUpdate]);

    useEffect(() => {
        if (deliveries.deliveriesColumns.columns && typeof deliveries.deliveriesColumns.columns.user_columns !== "undefined") {
            if (deliveries.deliveriesColumns.columns.user_columns.length !== 0) {
                setMeta(prevState => ({
                    ...prevState,
                    [`columns`]: JSON.stringify(deliveries.deliveriesColumns.columns.user_columns)
                }));
                Object.entries(deliveries.deliveriesColumns.columns.user_columns).map(([key, value]) => (
                    defaultColumns.splice(defaultColumns.length - 1, 0, {
                        field: value,
                        minWidth: 150,
                        sortable: false,
                        flex: 1,
                        headerName: key,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            if(key === "Weight"){
                                return  <span>{parseFloat(params.row.actual_weight).toFixed(2)}</span>
                            }else{
                                return getValueFromObject("row." + value, params)
                            }
                        }
                    })
                ))
            }
            setColumns(defaultColumns)
        }

    }, [deliveries.deliveriesColumns && deliveries.deliveriesColumns.columns])

    useEffect(() => {
        if (deliveries.deliveriesData && deliveries.deliveriesData.meta) {
            if(deliveries.deliveriesData.meta.shipment_status_category=="Label Generated"){
                setValue(1);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="In Transit"){
                setValue(2);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Issues"){
                setValue(3);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Delivered"){
                setValue(4);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Untracked"){
                setValue(5);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Voided"){
                setValue(6);
            }else{
                setValue(0);
            }
        }

    }, [deliveries.deliveriesData && deliveries.deliveriesData.meta])

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const onInputChangePagination = (page) => {
        setPageNumber(page)
        let pagenumber = ''
        if (page == '') {
            pagenumber = 1
        } else {
            pagenumber = page
        }
        setMeta({
            ...meta,
            ...{
                page: pagenumber
            }
        });
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
        setShowScan((type === "scan" && show === true) ? true : false)
    }

    const handleColumnsClick = (event) => {
        setAnchorEl(event.currentTarget);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const updateDynamicColumns = (clear = false) => {
        let data = columnCheckedObject
        if (clear == true) {
            data = {}
            setColumnCheckedObject({})
        }
        dispatch(saveDeliveriesColumns(data))
    }

    const handleColumnsClose = () => {
        setAnchorEl(null);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const onExportClick = () => {
        const qs = Object.keys(meta)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
            .join('&');
        console.log(qs)
        let url = process.env.REACT_APP_API_DOMAIN + '/labelgen/departure/export?' + qs;
        window.open(url)
    }

    function getValueFromObject(path, sourceObject) {
        let paths = path.split(".")
        try {
            paths.map((key) => (
                sourceObject = sourceObject[key]
            ))
            return sourceObject
        }
        catch (err) {
            return "-"
        }

    }

    function CustomTotalRows() {

        return (
            <Box 
                className="custom-total-rows"
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography variant="body2" sx={{ fontSize: '12.5px', fontWeight: 600, color: '#475569' }}>
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>{deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data && deliveries.deliveriesData.data.length}</strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>{(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.total) ? deliveries.deliveriesData.meta.total : 0}</strong>
                </Typography>
            </Box>
        )
    }


    function CustomPagesizeoptions() {

        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>Show</Typography>
                    <FormControl size="small" variant="outlined" sx={{ minWidth: 80, ...enterpriseControlInputStyles }}>
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={1000}>1000</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>entries</Typography>
                </Stack>
            </Box>
        )
    }

    function CustomToolbar() {

        return (
            <GridToolbarContainer
                sx={{
                    p: 2,
                    bgcolor: '#F8FAFC',
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {

        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2',
                            color: '#FFFFFF',
                            '&:hover': { backgroundColor: '#115293' }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.current_page}
                    count={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.last_page}
                    onChange={onChangePagination}
                />
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <PageSearch 
                        pagenumber={pageNumber} 
                        lastPage={deliveries?.deliveriesData?.meta?.last_page || 1} 
                        getpagenumber={onInputChangePagination} 
                    />
                </Box>
            </Box>
        );
    }



    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
            {(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.notification && deliveries.deliveriesData.notification.show) &&
                <Notification
                    is_open={deliveries.deliveriesData.notification.show}
                    messageType={deliveries.deliveriesData.notification.messageType}
                    messages={deliveries.deliveriesData.notification.messageContent}
                    handleClose={() => dispatch(resetDeliveriessNotifications())}
                />}
                {(deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.notification && deliveries.deliveriesColumns.notification.show) &&
                <Notification
                    is_open={deliveries.deliveriesColumns.notification.show}
                    messageType={deliveries.deliveriesColumns.notification.messageType}
                    messages={deliveries.deliveriesColumns.notification.messageContent}
                    handleClose={() => dispatch(resetDeliveriessNotifications())}
                />}
                {departureScanUpdate &&
                    departureScanUpdate.notification &&
                    departureScanUpdate.notification.show && (
                    <Notification
                        is_open={departureScanUpdate.notification.show}
                        messageType={departureScanUpdate.notification.messageType}
                        messages={departureScanUpdate.notification.messageContent}
                        handleClose={() => dispatch(resetLabelData())}
                    />
                )}
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            
            <Card 
                className="scmaincard"
                sx={{ 
                    width: '100%', 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }}
            >
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2.5,
                        borderBottom: '1px solid #E2E8F0',
                        flexWrap: 'wrap',
                        gap: 2
                    }}
                >
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ flexWrap: 'wrap', gap: 1.5 }}>
                        <Typography 
                            variant="h5" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 800, 
                                color: '#0F172A',
                                letterSpacing: '-0.5px',
                                margin: 0
                            }}
                        >
                            Departure Scan
                        </Typography>
                        
                        <Box 
                            sx={{ 
                                display: 'inline-flex', 
                                py: 0.6, 
                                px: 1.5, 
                                borderRadius: '8px', 
                                backgroundColor: 'rgba(25, 118, 210, 0.06)', 
                                border: '1px solid rgba(25, 118, 210, 0.15)' 
                            }}
                        >
                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1976d2' }}>
                                Today's Scan Count: {deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.today_scan_count}
                            </Typography>
                        </Box>
                    </Stack>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, p: 0, m: 0 }}>
                        <Tooltip title="Scan View" placement="top">
                            <IconButton sx={departurePageUtilityIconStyles(showScan)} onClick={() => onMenuClick("scan", !showScan)}>
                                <AdfScannerOutlinedIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Search Options" placement="top">
                            <IconButton sx={departurePageUtilityIconStyles(showSearch)} onClick={() => onMenuClick("search", !showSearch)}>
                                <SearchIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Filter Panels" placement="top">
                            <IconButton sx={departurePageUtilityIconStyles(showFilter)} onClick={() => onMenuClick("filter", !showFilter)}>
                                <FilterAltOutlinedIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Export Shipments" placement="top">
                            <IconButton sx={departurePageUtilityIconStyles(false)} onClick={() => onExportClick()}>
                                <FileDownloadIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Toggle Columns" placement="top">
                            <IconButton
                                id="dynamic-column-positioned-button"
                                aria-controls={showDynamicColumn ? "dynamic-column-positioned-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={showDynamicColumn ? 'true' : undefined}
                                sx={departurePageUtilityIconStyles(showDynamicColumn)}
                                onClick={handleColumnsClick}
                            >
                                <ViewColumnSharpIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                
                {showScan &&
                    <Box 
                        sx={{ 
                            p: 3, 
                            backgroundColor: '#F8FAFC', 
                            borderBottom: '1px solid #E2E8F0',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        {departureScanUpdate && departureScanUpdate.loading === true && (
                            <LinearProgress sx={{ height: '3px', mb: 2, borderRadius: '2px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                        )}
                        
                        <Box 
                            sx={{ 
                                maxWidth: 500, 
                                mx: 'auto', 
                                p: 2, 
                                bgcolor: '#FFFFFF', 
                                borderRadius: '12px', 
                                border: '1px solid #E2E8F0', 
                                boxShadow: '0 1px 3px rgba(0,0,0,0.02)' 
                            }}
                        >
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-start">
                                <Box sx={{ flex: 1, width: '100%', minHeight: '40px' }}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        name="departure_tracking_number"
                                        label="Tracking Number"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={detartureTrackingNumber}
                                        onInput={(e) => {
                                            setDetartureTrackingNumber(e.target.value)
                                            settrackingnumberSubmit(false)
                                        }}
                                        InputProps={{
                                            endAdornment: detartureTrackingNumber ? (
                                              <IconButton size="small" onClick={() => onInputClear()} sx={{ color: '#94A3B8' }}>
                                                <ClearIcon fontSize="small" />
                                              </IconButton>
                                            ) : undefined,
                                        }}
                                        onKeyUp={(event) => {
                                            if (event.key == "Enter"){
                                                departureScanHandleSubmit();
                                            }else{
                                                deperturScanValidate()
                                            }
                                        }}
                                        inputRef={(tracking_numberinput) => {
                                            if (detartureTrackingNumber=='' && trackingnumberSubmit==false) 
                                                tracking_numberinput && tracking_numberinput.focus()
                                        }}
                                        error={!!detartureTrackingNumberErrors}
                                        helperText={detartureTrackingNumberErrors}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '10px',
                                                '& fieldset': { borderColor: '#E2E8F0' },
                                                '&:hover fieldset': { borderColor: '#CBD5E1' },
                                                '&.Mui-focused fieldset': { borderColor: '#1976d2' }
                                            },
                                            '& .MuiFormHelperText-root': { fontWeight: 500, mt: 0.5, mx: 0.5 }
                                        }}
                                    />
                                </Box>
                                <Button
                                    variant="contained"
                                    onClick={departureScanHandleSubmit}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 4,
                                        boxShadow: 'none',
                                        width: { xs: '100%', sm: 'auto' },
                                        backgroundColor: '#1976d2',
                                        color: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                    }}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </Box>
                    </Box>  
                }  
                
                <Box>
                    {anchorEl != null && <DynamicColumns
                        visible={showDynamicColumn}
                        anchorEl={anchorEl}
                        columns={deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.columns}
                        columnCheckedObject={columnCheckedObject}
                        setColumnCheckedObject={setColumnCheckedObject}
                        updateDynamicColumns={updateDynamicColumns}
                        handleColumnsClose={handleColumnsClose}
                        loading={deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.loading}
                    />}
                    <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                    <Filters visible={showFilter} meta={meta} setMeta={setMeta} />
                </Box>
                
                <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                            '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                            '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' }, '&.Mui-selected': { backgroundColor: 'rgba(25, 118, 210, 0.04)', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } } },
                            '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                            '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                        }}
                        getRowId={(row) => row.id}
                        rows={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData
                        }}
                        loading={
                            (deliveries && deliveries.deliveriesData && deliveries.deliveriesData.loading)
                        }
                    />
                </Box>
            </Card>
            <TrackingDrawer
                visible={trackingDrawerVisible} message={trackingMessage} isMultiPiece={isMultiPiece} onClose={onClose}
            />
            <OrderDrawer
                visible={orderDrawerVisible} onClose={orderOnClose}
            />
        </Box>
    )
}

export default DeparturePage;